import type { ThemeMode } from '@/types/appearance';

export type ResolvedThemeMode = 'light' | 'dark';

export const THEME_MEDIA_QUERY = '(prefers-color-scheme: dark)';

export const getResolvedThemeMode = (mode: ThemeMode): ResolvedThemeMode => {
  if (mode === 'system') {
    if (typeof window !== 'undefined') {
      return window.matchMedia(THEME_MEDIA_QUERY).matches ? 'dark' : 'light';
    }
    return 'light';
  }

  return mode;
};

export const applyThemeModeToDocument = (mode: ThemeMode | ResolvedThemeMode): ResolvedThemeMode => {
  const resolvedMode = mode === 'system' ? getResolvedThemeMode(mode) : mode;

  if (typeof document === 'undefined') {
    return resolvedMode;
  }

  const root = document.documentElement;
  root.setAttribute('data-theme-mode', resolvedMode);
  root.classList.toggle('dark', resolvedMode === 'dark');
  root.style.colorScheme = resolvedMode;

  return resolvedMode;
};
